<template>
    <div>
      {{ this.uppercasedString }}
    </div>
  </template>
  
  <script>
  export default {
    name: "UppercasedStringRenderer",
    props: ["object", "columnKey"],
    computed: {
        uppercasedString: function () {
            return this.object[this.columnKey]?.toUpperCase();
        }
    }
  };
  </script>
  